export default __webpack_public_path__ + "static/media/ico-plegar-menu.1a103178.svg";